<tag-area>
    <div class="relative">
        <label if="{ props.label }" for="{ props.ckey }" class="block text-sm font-medium leading-6 text-gray-900">{ props.label }</label>
        <div class="flex flex-wrap items-center gap-2 bg-gray-100 p-2 rounded-lg { props.label ? 'mt-2' : '' }">
            <tag each="{ tag in state.tags }" 
                 text="{ tag }"
                 ckey="{ props.ckey }"></tag>
            <input 
                class="flex-grow bg-transparent border-none outline-none focus:ring-0 sm:text-sm" 
                placeholder="{ props.placeholder }" 
                disabled="{ props.is_disabled }" 
                onkeydown="{
                            handleEnter
                        }"                         
                oninput="{ handleInput }"
                value="{ state.value }" 
                name="{ props.ckey }" 
                id="{ props.ckey }">
        </div>
        <p if="{ props.show_help }" class="mt-3 text-sm leading-6 text-gray-600"><slot/></p>
    </div>

    <script>
        import eventBus from '/src/utils/event-bus'
        import { EVENTS } from '/src/utils/constants'

        export default {
            onBeforeMount(props, state) {
                let tags = []
                if (Array.isArray(props.value)) {
                    tags = props.value
                } else if ((typeof props.value === 'string' || props.value instanceof String) && props.value.length > 0) {
                    tags = props.value.split(",").map(function (item) {
                        return item.trim()
                    })
                }
                this.state = {
                    tags: tags, // Array dei tag
                    value: '' // Input corrente
                }
                eventBus.on(EVENTS.INPUT.UPDATE, this.handleUpdateInput)
                eventBus.on(EVENTS.INPUT.RESET, this.handleResetInput)
                eventBus.on(EVENTS.INPUT.DELETE, this.handleDeleteTag);
            },

            onBeforeUnmount(props, state) {
                eventBus.off(EVENTS.INPUT.UPDATE, this.handleUpdateInput)
                eventBus.off(EVENTS.INPUT.RESET, this.handleResetInput)
                eventBus.off(EVENTS.INPUT.DELETE, this.handleDeleteTag);
            },

            handleInput(e) {
                const value = e.target.value;

                // Permetti solo numeri e un singolo punto
                const filteredValue = value.replace(/[^0-9.]/g, '').replace(/\.(?=.*\.)/g, ''); // Filtra i caratteri non consentiti e rimuovi punti multipli

                if (filteredValue !== value) {
                    this.$("input").value = filteredValue; // Aggiorna visivamente l'input
                }

                this.update({value: filteredValue});
            },

            handleEnter(e) {
                if (e.key === 'Enter') {
                    e.preventDefault(); // Evita l'invio del form

                    const tag = this.state.value.trim();
                    if (tag) {
                        this.addTag(tag); // Aggiungi il tag
                        this.update({value: ''}); // Resetta l'input
                    }
                }
            },

            handleUpdateInput(e) {
                if (e.ckey === this.props.ckey) {
                    this.update({
                        value: e.value
                    });
                }
            },

            handleResetInput(e) {
                if (e.ckey === this.props.ckey) {
                    this.update({
                        tags: [],
                        value: ''
                    });
                    this.$("input").value = ""; // Resetta visivamente l'input
                    eventBus.trigger(EVENTS.INPUT.UPDATED, {
                        ckey: this.props.ckey,
                        value: []
                    });
                }
            },

            handleDeleteTag(e) {
                // Verifica che l'evento sia destinato a questo componente
                if (e.ckey === this.props.ckey) {
                    this.update({
                        tags: this.state.tags.filter(tag => tag !== e.text)
                    });
                    eventBus.trigger(EVENTS.INPUT.UPDATED, {
                        ckey: this.props.ckey,
                        value: this.state.tags
                    });
                }
            },

            addTag(tag) {
                if (!this.state.tags.includes(tag)) {
                    this.update({
                        tags: [...this.state.tags, tag]
                    });
                    eventBus.trigger(EVENTS.INPUT.UPDATED, {
                        ckey: this.props.ckey,
                        value: this.state.tags
                    });
                }
            }
        }
    </script>
</tag-area>
